import { useMemo, useState } from 'react';

export const isStep = <const T extends string, U extends T>(
  step: T | undefined,
  ...desired: U[]
): step is U => step !== undefined && desired.includes(step as U);

export default function useSteps<const T extends string>(...steps: T[]) {
  const [currentIndex, setCurrentIndex] = useState(0);

  return useMemo(
    () => ({
      step: steps[currentIndex],
      advanceStep: () => setCurrentIndex((current) => (current + 1) % steps.length),
      gotoStep: (step: T) => setCurrentIndex(steps.indexOf(step)),
      stepCount: steps.length,
      stepId: currentIndex + 1,
      stepMatches: <U extends T>(...desired: U[]) => isStep(steps[currentIndex], ...desired),
      resetSteps: () => setCurrentIndex(0),
    }),
    [currentIndex],
  );
}
